import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["className", "clearButtonText", "customInputElement", "dataTestId", "enableCustomValidation", "enableIsRequiredValidation", "errorMessage", "hasCharacterCount", "hasClearButton", "hasError", "helperText", "hideBorder", "icon", "iconPosition", "id", "inputClassName", "inputDivider", "isDisabled", "isFocused", "isObscured", "isReadOnly", "isRequired", "label", "labelRef", "maxInlineLabelWidth", "maxLength", "minLength", "name", "onBlur", "onChange", "onClick", "onError", "onFocus", "onInputClear", "placeholder", "prefixText", "renderSuffixElement", "size", "suffixText", "type", "value"];

var _templateObject, _baseInputSizes, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BaseInputField, InputErrorText } from "../../blocks";
import { BORDER_POSITIONS, DIVIDER_POSITIONS, INPUT_ICON_POSITIONS, INPUT_SIZES } from "../../constants";
import { BaseInput, InputCharacterCount, InputClearIcon, InputHelperText, InputIcon, InputLabel, InputPrefix, InputSuffix, InputSuffixElement } from "../../elements";
import { INPUT_ERROR_TYPES } from "../../errors";
import { ie11ReadOnlyClickHandler, moveInputCursorToStart } from "../../shared";
import { getRem } from "./../../../core";
import { useOnError } from "./../../../utilities";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledBaseInputWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 100%;\n"])));
var baseInputSizes = (_baseInputSizes = {}, _defineProperty(_baseInputSizes, INPUT_SIZES.SMALL, getRem(40)), _defineProperty(_baseInputSizes, INPUT_SIZES.STANDARD, getRem(48)), _defineProperty(_baseInputSizes, INPUT_SIZES.LARGE, getRem(56)), _baseInputSizes);
var StyledBaseInput = styled(BaseInput)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex-direction: row;\n  height: ", ";\n"])), function (_ref) {
  var size = _ref.size;
  return baseInputSizes[size];
});
var StyledInputWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  width: 70%;\n"])));
var StyledInputFieldWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var StyledInputSuffix = styled(InputSuffix)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding-right: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.size.spacing.small.value;
});
var StyledInputField = styled(BaseInputField)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  outline: none;\n  text-align: ", ";\n"])), function (_ref3) {
  var textalign = _ref3.textalign;
  return textalign;
});
var StyledHelperTextContainer = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var Input = /*#__PURE__*/React.forwardRef(function (_ref4, ref) {
  var _classNames, _classNames2;

  var className = _ref4.className,
      clearButtonText = _ref4.clearButtonText,
      customInputElement = _ref4.customInputElement,
      dataTestId = _ref4.dataTestId,
      enableCustomValidation = _ref4.enableCustomValidation,
      enableIsRequiredValidation = _ref4.enableIsRequiredValidation,
      errorMessage = _ref4.errorMessage,
      hasCharacterCount = _ref4.hasCharacterCount,
      hasClearButton = _ref4.hasClearButton,
      hasError = _ref4.hasError,
      helperText = _ref4.helperText,
      hideBorder = _ref4.hideBorder,
      icon = _ref4.icon,
      iconPosition = _ref4.iconPosition,
      id = _ref4.id,
      inputClassName = _ref4.inputClassName,
      inputDivider = _ref4.inputDivider,
      isDisabled = _ref4.isDisabled,
      isFocused = _ref4.isFocused,
      isObscured = _ref4.isObscured,
      isReadOnly = _ref4.isReadOnly,
      isRequired = _ref4.isRequired,
      label = _ref4.label,
      labelRef = _ref4.labelRef,
      maxInlineLabelWidth = _ref4.maxInlineLabelWidth,
      maxLength = _ref4.maxLength,
      minLength = _ref4.minLength,
      name = _ref4.name,
      onBlur = _ref4.onBlur,
      onChange = _ref4.onChange,
      onClick = _ref4.onClick,
      onError = _ref4.onError,
      onFocus = _ref4.onFocus,
      onInputClear = _ref4.onInputClear,
      placeholder = _ref4.placeholder,
      prefixText = _ref4.prefixText,
      renderSuffixElement = _ref4.renderSuffixElement,
      size = _ref4.size,
      suffixText = _ref4.suffixText,
      type = _ref4.type,
      value = _ref4.value,
      other = _objectWithoutProperties(_ref4, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isBlurred = _useState2[0],
      setIsBlurred = _useState2[1];

  var _useState3 = useState(isFocused),
      _useState4 = _slicedToArray(_useState3, 2),
      hasFocus = _useState4[0],
      setHasFocus = _useState4[1];

  var handleBlur = function handleBlur(event) {
    moveInputCursorToStart(event.target, value);
    onBlur(event, {
      setIsBlurred: setIsBlurred
    });
    setHasFocus(false);
    setIsBlurred(true);
  };

  var handleClick = function handleClick(event) {
    if (isReadOnly) {
      ie11ReadOnlyClickHandler(event);
    }

    onClick(event);
  };

  var handleFocus = function handleFocus(event) {
    onFocus(event);
    setHasFocus(true);
  };

  var isEmpty = !value || !value.toString().length;
  var isRequiredError = enableIsRequiredValidation && isRequired && isEmpty && isBlurred;
  var minLengthError = value.length < minLength && !isEmpty && !hasFocus;
  var errors = [isRequiredError && INPUT_ERROR_TYPES.REQUIRED, minLengthError && INPUT_ERROR_TYPES.MIN_LENGTH].filter(Boolean);
  useOnError({
    errors: errors,
    onError: onError
  });
  var updatedHasError = enableCustomValidation ? hasError : errors.length > 0;
  var isInvalid = !isDisabled && !isReadOnly && updatedHasError;
  var showHelperText = !isInvalid && !!helperText;
  var showErrorMessage = !!isInvalid && !!errorMessage;
  var isIconTrailing = !!icon && iconPosition === INPUT_ICON_POSITIONS.TRAILING || !!renderSuffixElement;
  var isIconLeading = !!icon && iconPosition === INPUT_ICON_POSITIONS.LEADING || !!renderSuffixElement && !!icon;
  var inputLabelId = "input-".concat(id, "-label");
  var inputPrefixId = "input-".concat(id, "-prefix");
  var inputSuffixId = "input-".concat(id, "-suffix");
  var inputHelperTextId = "input-".concat(id, "-help-text");
  var inputErrorTextId = "input-".concat(id, "-error-text");
  var inputAriaLabelledBy = classNames(inputLabelId, (_classNames = {}, _defineProperty(_classNames, inputPrefixId, !!prefixText), _defineProperty(_classNames, inputSuffixId, !!suffixText), _classNames));
  var inputAriaDescribedBy = classNames((_classNames2 = {}, _defineProperty(_classNames2, inputErrorTextId, showErrorMessage), _defineProperty(_classNames2, inputHelperTextId, showHelperText), _classNames2));

  var handleClear = function handleClear(event) {
    event.preventDefault();
    onInputClear(event);
    setIsBlurred(false);
    setHasFocus(isFocused);
  };

  return /*#__PURE__*/_jsxs(StyledBaseInputWrapper, {
    className: className,
    "data-testid": dataTestId ? "".concat(dataTestId, "-wrapper") : undefined,
    children: [/*#__PURE__*/_jsxs(StyledBaseInput, {
      "aria-describedby": inputAriaDescribedBy,
      "aria-labelledby": inputAriaLabelledBy,
      className: inputClassName,
      "data-testid": dataTestId ? "base-".concat(dataTestId) : undefined,
      disabled: isDisabled,
      hasError: isInvalid,
      hideBorder: hideBorder,
      htmlFor: id,
      inputDivider: inputDivider,
      isDisabled: isDisabled,
      isFocused: hasFocus,
      isReadOnly: isReadOnly,
      isRequired: isRequired,
      size: size,
      ref: labelRef,
      children: [!!icon && iconPosition === INPUT_ICON_POSITIONS.LEADING && /*#__PURE__*/_jsx(InputIcon, {
        "data-testid": dataTestId ? "".concat(dataTestId, "-icon") : undefined,
        hasError: isInvalid,
        icon: icon,
        isFocused: hasFocus,
        position: INPUT_ICON_POSITIONS.LEADING
      }), /*#__PURE__*/_jsxs(StyledInputWrapper, {
        children: [/*#__PURE__*/_jsx(InputLabel, {
          "data-testid": dataTestId ? "".concat(dataTestId, "-label") : undefined,
          hasError: !!isInvalid,
          id: inputLabelId,
          isDisabled: isDisabled,
          isFocused: hasFocus,
          isReadOnly: isReadOnly,
          isRequired: isRequired,
          label: label,
          size: size,
          withPrefixElement: isIconLeading,
          withSuffixElement: isIconTrailing
        }), /*#__PURE__*/_jsxs(StyledInputFieldWrapper, {
          children: [!!prefixText && /*#__PURE__*/_jsx(InputPrefix, {
            id: inputPrefixId,
            "data-testid": dataTestId ? "".concat(dataTestId, "-prefix") : undefined,
            isDisabled: isDisabled,
            size: size,
            text: prefixText
          }), /*#__PURE__*/_jsx(StyledInputField, _objectSpread({
            "aria-describedby": inputAriaDescribedBy,
            "aria-labelledby": inputAriaLabelledBy,
            as: customInputElement,
            className: inputClassName,
            "data-testid": dataTestId ? "".concat(dataTestId, "-input-field") : undefined,
            disabled: isDisabled,
            hasError: isInvalid,
            id: id,
            isObscured: isObscured,
            maxLength: maxLength,
            minLength: minLength,
            name: name,
            onBlur: handleBlur,
            onChange: onChange,
            onClick: handleClick,
            onFocus: handleFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: ref,
            required: isRequired,
            size: size,
            type: type,
            value: value
          }, other)), !!suffixText && /*#__PURE__*/_jsx(StyledInputSuffix, {
            id: inputSuffixId,
            "data-testid": dataTestId ? "".concat(dataTestId, "-suffix") : undefined,
            isDisabled: isDisabled,
            size: size,
            text: suffixText
          })]
        })]
      }), !isEmpty && hasClearButton && /*#__PURE__*/_jsx(InputClearIcon, {
        clearButtonText: clearButtonText,
        dataTestId: dataTestId,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        onClick: handleClear
      }), !!icon && iconPosition === INPUT_ICON_POSITIONS.TRAILING && /*#__PURE__*/_jsx(InputIcon, {
        hasError: isInvalid,
        "data-testid": dataTestId ? "".concat(dataTestId, "-storybook-icon") : undefined,
        icon: icon,
        isFocused: hasFocus,
        position: INPUT_ICON_POSITIONS.TRAILING
      }), !!renderSuffixElement && /*#__PURE__*/_jsx(InputSuffixElement, {
        dataTestId: dataTestId ? "".concat(dataTestId, "-suffix-element") : undefined,
        hasError: isInvalid,
        isDisabled: isDisabled,
        isFocused: hasFocus,
        children: renderSuffixElement()
      })]
    }), /*#__PURE__*/_jsxs(StyledHelperTextContainer, {
      children: [showHelperText && /*#__PURE__*/_jsx(InputHelperText, {
        id: inputHelperTextId,
        dataTestId: dataTestId ? "".concat(dataTestId, "-helper") : undefined,
        text: helperText
      }), showErrorMessage && /*#__PURE__*/_jsx(InputErrorText, {
        id: inputErrorTextId,
        dataTestId: dataTestId ? "".concat(dataTestId, "-error") : undefined,
        text: errorMessage
      }), hasCharacterCount && /*#__PURE__*/_jsx(InputCharacterCount, {
        "data-testid": dataTestId ? "".concat(dataTestId, "-count") : undefined,
        maxLength: maxLength,
        value: value
      })]
    })]
  });
});
Input.propTypes = {
  /** Label for clear icon button */
  clearButtonText: PropTypes.string,

  /** Ability to supply a different input element instead of the default one */
  customInputElement: PropTypes.elementType,

  /** Id value used for testing */
  dataTestId: PropTypes.string,

  /** If true, custom validation is being enabled instead of built in component validation */
  enableCustomValidation: PropTypes.bool,

  /** If true, field becomes invalid when empty. It does not get invalid if false. Default value is true */
  enableIsRequiredValidation: PropTypes.bool,

  /** Message to be displayed when input is in error state */
  errorMessage: PropTypes.node,

  /** When true, displays character count for input */
  hasCharacterCount: PropTypes.bool,

  /** If true, Input has a clear button to clear the value of input */
  hasClearButton: PropTypes.bool,

  /** When true, input is in error state */
  hasError: PropTypes.bool,

  /** Text to be displayed as a helper text near the input field */
  helperText: PropTypes.node,

  /** Defines which side of input container border should be hidden */
  hideBorder: PropTypes.oneOf(Object.values(BORDER_POSITIONS)),

  /** Icon to be displayed in input field */
  icon: PropTypes.node,

  /** Sets the position of icon */
  iconPosition: PropTypes.oneOf(Object.values(INPUT_ICON_POSITIONS)),

  /** Identifier of the input component */
  id: PropTypes.string.isRequired,

  /** Adds additional class to input tag */
  inputClassName: PropTypes.string,

  /** Defines the side of vertical divider */
  inputDivider: PropTypes.oneOf(Object.values(DIVIDER_POSITIONS)),

  /** If true, input is disabled and value of it cannot be edited */
  isDisabled: PropTypes.bool,

  /** If true, visually applies focused input styles */
  isFocused: PropTypes.bool,

  /** If true, changes password mask dots to be bigger */
  isObscured: PropTypes.bool,

  /** If true, input is in read only state, value cannot be edited */
  isReadOnly: PropTypes.bool,

  /** If true, isRequired asterisk will be shown */
  isRequired: PropTypes.bool,

  /** Label of the input field */
  label: PropTypes.node.isRequired,

  /** Reference to the label element */
  labelRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }),

  /** Maximum amount of characters input field can have */
  maxLength: PropTypes.number,

  /** @ignore */
  maxInlineLabelWidth: PropTypes.string,

  /** Minimum amount of characters to be entered so the input field would not be in error state */
  minLength: PropTypes.number,

  /** Name of the input */
  name: PropTypes.string.isRequired,

  /** Callback to be called when input looses focus */
  onBlur: PropTypes.func,

  /** Callback to be called when input's value is being changed by user interaction */
  onChange: PropTypes.func.isRequired,

  /** Callback to be called when input is clicked */
  onClick: PropTypes.func,

  /** Callback to be called when inputs validation fails */
  onError: PropTypes.func,

  /** Callback that is called when Input has been focused */
  onFocus: PropTypes.func,

  /** Callback to be called when  clear button is clicked */
  onInputClear: PropTypes.func,

  /** Text to be displayed when input is empty */
  placeholder: PropTypes.node,

  /** String to be displayed before the input value. Prefix text should be 1 character. */
  prefixText: PropTypes.node,

  /** Clickable icon in input field, which will toggle input text visibility */
  renderSuffixElement: PropTypes.func,

  /** Set the size of the input */
  size: PropTypes.oneOf(Object.values(INPUT_SIZES)),

  /** String to be displayed after the input value. Text should contain up to 5 characters, to not get cutted */
  suffixText: PropTypes.node,

  /** Set the text alignment inside Input field */
  textalign: PropTypes.string,

  /** Standard html input tag type attribute */
  type: PropTypes.string,

  /** Current value of the input field */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
Input.defaultProps = {
  clearButtonText: 'clear input',
  customInputElement: undefined,
  dataTestId: undefined,
  enableCustomValidation: false,
  enableIsRequiredValidation: true,
  errorMessage: '',
  hasCharacterCount: false,
  hasClearButton: false,
  hasError: false,
  helperText: '',
  hideBorder: BORDER_POSITIONS.NONE,
  icon: undefined,
  iconPosition: INPUT_ICON_POSITIONS.TRAILING,
  inputClassName: '',
  inputDivider: DIVIDER_POSITIONS.NONE,
  isDisabled: false,
  isFocused: false,
  isObscured: false,
  isReadOnly: false,
  isRequired: false,
  labelRef: undefined,
  maxInlineLabelWidth: undefined,
  maxLength: 100,
  minLength: 0,
  onBlur: function onBlur() {},
  onClick: function onClick() {},
  onError: function onError() {},
  onFocus: function onFocus() {},
  onInputClear: function onInputClear() {},
  placeholder: '',
  prefixText: '',
  renderSuffixElement: undefined,
  size: INPUT_SIZES.STANDARD,
  suffixText: '',
  textalign: 'unset',
  type: 'text'
};
export { Input };